export default "__VITE_ASSET__e341PVHQ__"